import * as React from "react";
import { Box, Typography, useTheme, Grid, InputBase } from "@mui/material";
import TableUserList from "../../components/TableUserList";
import { useEffect, useState, useRef } from "react";
import axios from "axios";
import { API_ENDPOINT_URL } from "../../util/api";
import { getLocalItem } from "../../util/helper";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import AddIcon from "@mui/icons-material/Add";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useParams } from "react-router-dom";
import { formatDateYMD_HMS } from "../../util/helper";
import _ from "lodash";
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import { useNavigate } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { parseISO, format } from 'date-fns';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';


const UserEdit = () => {
  const navigate = useNavigate();
  const { userId } = useParams();
  const [loading, setLoading] = useState(false);
  const token = getLocalItem("key");
  const [validate, setValidate] = useState(false);
  const [data, setData] = useState({
    username: "",
    email: "",
    is_superuser: false,
    is_staff: false,
    is_active: false,
    date_joined: "",
    expiration_date: null
  });

  const [showAlert, setShowAlert] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState('success');
  const [alertMessage, setAlertMessage] = useState('');

  const [openResetPassword, setOpenResetPassword] = useState(false);
  const handleClosePasswordReset = () => {
    setOpenResetPassword(false)
  };
  const handleOpenPasswordReset = () => {
    setOpenResetPassword(true)
  };

  useEffect(() => {
    if (userId) {
      setLoading(true);
      axios
        .get(`${API_ENDPOINT_URL}/users/${userId}/`, {
          params: {},
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          setData(response.data);
        })
        .catch((error) => { })
        .finally(() => setLoading(false));
    }
  }, [userId, token]);

  const handleRequest = (url, data, successMessage, errorMessage) => {
    axios
      .patch(url, data, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        setAlertSeverity('success');
        setAlertMessage(successMessage);
        if ('Update user successfully!' === successMessage) {
          setTimeout(() => {
            navigate("/user-list");
          }, 500);
        }
      })
      .catch((error) => {
        setAlertSeverity('error');
        setAlertMessage(errorMessage);
      })
      .finally(() => {
        setShowAlert(true);
        window.scrollTo({ top: 0 });
        setTimeout(() => {
          setShowAlert(false);
        }, 4000); // Hide alert after 4 seconds
      });
  };

  const handleUpdate = () => {
    if (validate) {
      return
    }
    const formattedExpirationDate = data.expiration_date
    ? dayjs(formatDateYMD_HMS(data.expiration_date)).format('YYYY-MM-DD')
    : null;

    const url = `${API_ENDPOINT_URL}/update-user/${userId}/`;
    const data_tmp = {
      username: data.username,
      email: data.email,
      is_superuser: data.is_superuser,
      is_staff: data.is_staff,
      is_active: data.is_active,
      expiration_date: formattedExpirationDate,
    };
    const successMessage = 'Update user successfully!';
    const errorMessage = 'Error updating user.';
    handleRequest(url, data_tmp, successMessage, errorMessage);
  };

  const handleSendPasswordReset = () => {
    handleClosePasswordReset()
    setLoading(true)
    const url = `${API_ENDPOINT_URL}/update-user/${userId}/`;
    const data_tmp = {
      is_reset_password: true
    };
    const successMessage = 'Reset password successfully!';
    const errorMessage = 'Error updating password.';
    handleRequest(url, data_tmp, successMessage, errorMessage);
    setLoading(false)
  };


  const handleCheckboxChange = (name) => (event) => {
    setData((prevData) => ({
      ...prevData,
      [name]: event.target.checked,
    }));
  };

  return (
    <>
      {showAlert && (
        <Stack sx={{ width: '300px', marginLeft: 'auto' }} spacing={2}>
          <Alert variant="filled" severity={alertSeverity}>
            {alertMessage}
          </Alert>
        </Stack>
      )}
      <Dialog
        open={openResetPassword}
        onClose={handleClosePasswordReset}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Reset Password ?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            A new password will be sent to email <span style={{ fontWeight: 'bold' }}>{data.email}</span>.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClosePasswordReset}>Cancel</Button>
          <Button onClick={handleSendPasswordReset} autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
      <Box
        mt="50px"
        sx={{
          width: "95%",
          textAlign: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            width: "100%",
            textAlign: "center",
          }}
        >
          <Grid container spacing={0}>
            <Grid item lg={6} sm={12} md={6}>
              <Box>
                <Typography
                  variant="h1"
                  fontSize={40}
                  fontWeight="bold"
                  color="#2699fb"
                  textAlign="left"
                >
                  User Detail
                </Typography>
              </Box>
            </Grid>
          </Grid>

          <Grid
            container
            spacing={0}
            ml="16px"
            mt={8}
            item
            xs={12}
            sm={12}
            md={12}
            lg={4}
            textAlign="left"
          >
            <Box>
              <Typography variant="h6" fontSize={15} fontWeight="bold">
                Username
              </Typography>
              <InputBase
                placeholder="Username"
                value={data ? data.username : ""}
                sx={{
                  marginTop: "5px",
                  backgroundColor: "#f1f9ff",
                  width: "100%",
                  border: "2px solid #bce0fd",
                  borderRadius: "10px",
                  color: "#2699fb",
                  padding: "8px 15px 8px 15px",
                }}
              />
            </Box>
          </Grid>
          <Grid container spacing={2} ml="0px" mt={0}>
            {/* Section 1 - Email input */}
            <Grid item xs={12} sm={12} md={6} lg={6} textAlign="left">
              <Box mt={1}>
                <Typography variant="h6" fontSize={15} fontWeight="bold">
                  E-mail
                </Typography>
                <InputBase
                  placeholder="Email"
                  value={data ? data.email : ""}
                  sx={{
                    marginTop: "5px",
                    backgroundColor: "#f1f9ff",
                    width: "100%",
                    border: "2px solid #bce0fd",
                    borderRadius: "10px",
                    color: "#2699fb",
                    padding: "8px 15px 8px 15px",
                  }}
                />
              </Box>
            </Grid>

            {/* Section 2 - Button 1 */}
            <Grid item xs={12} sm={12} md={6} lg={2} textAlign="left">
              <Box mt={1}>
                {loading ? (
                  <Box padding="11px" mt={4} sx={{ display: 'flex' }}>
                    <CircularProgress />
                  </Box>
                ) : (
                  <>
                    <Box
                      mt={5}
                      padding="11px"
                      sx={{
                        backgroundColor: "#2699fb",
                        color: "white",
                        borderRadius: "4px",
                        "&:hover": {
                          cursor: "pointer",
                        },
                        width: 200,
                      }}
                      onClick={handleOpenPasswordReset}
                    >
                      <Typography
                        variant="body1"
                        gutterBottom
                        textAlign="center"
                        m={0}
                        cursor="pointer"
                      >
                        Send Password Reset
                      </Typography>
                    </Box>
                  </>
                )}
              </Box>
            </Grid>
          </Grid>
          <Grid container spacing={2} alignItems="center" sx={{ mt: "10px", ml: "0px" }}>
            <Grid item xs={2} display="inline-flex">
              <Box mt={1} display="flex" justifyContent="flex-start">
                <Typography style={{ fontWeight: "bold" }}>isSuperuser</Typography>
              </Box>
            </Grid>
            <Grid item xs={10} display="inline-flex">
              <Box mt={1} display="flex" justifyContent="flex-start">
                <FormControlLabel
                  value={data.is_superuser ? data.is_superuser : false}
                  control={
                    <Checkbox
                      checked={data.is_superuser ? data.is_superuser : false}
                      onChange={handleCheckboxChange('is_superuser')}
                    />
                  }
                  labelPlacement="start"
                />
              </Box>
            </Grid>
          </Grid>

          <Grid container spacing={2} alignItems="center" sx={{ ml: "0px" }}>
            <Grid item xs={2} display="inline-flex">
              <Box mt={1} display="flex" justifyContent="flex-start">
                <Typography style={{ fontWeight: "bold" }}>isStaff</Typography>
              </Box>
            </Grid>
            <Grid item xs={10} display="inline-flex">
              <Box mt={1} display="flex" justifyContent="flex-start">
                <FormControlLabel
                  value={data.is_staff ? data.is_staff : false}
                  control={
                    <Checkbox
                      checked={data.is_staff ? data.is_staff : false}
                      onChange={handleCheckboxChange('is_staff')}
                    />
                  }
                  labelPlacement="start"
                />
              </Box>
            </Grid>
          </Grid>

          <Grid container spacing={2} alignItems="center" sx={{ ml: "0px" }}>
            <Grid item xs={2} display="inline-flex">
              <Box mt={1} display="flex" justifyContent="flex-start">
                <Typography style={{ fontWeight: "bold" }}>isActive</Typography>
              </Box>
            </Grid>
            <Grid item xs={10} display="inline-flex">
              <Box mt={1} display="flex" justifyContent="flex-start">
                <FormControlLabel
                  value={data.is_active ? data.is_active : false}
                  control={
                    <Checkbox
                      checked={data.is_active ? data.is_active : false}
                      onChange={handleCheckboxChange('is_active')}
                    />
                  }
                  labelPlacement="start"
                />
              </Box>
            </Grid>
          </Grid>

          <Grid container spacing={2} alignItems="center" sx={{ mt: "0px", ml: "0px" }}>
            <Grid item xs={2} display="inline-flex">
              <Box mt={1} display="flex" justifyContent="flex-start">
                <Typography style={{ fontWeight: "bold" }}>Created:</Typography>
              </Box>
            </Grid>
            <Grid item xs={10} display="inline-flex">
              <Box mt={1} ml={3} display="flex" justifyContent="flex-start">
                <Typography variant="h6" fontSize={15} fontWeight="bold">
                  {data.date_joined ? formatDateYMD_HMS(data.date_joined) : ""}
                </Typography>
              </Box>
            </Grid>
          </Grid>

          <Grid container spacing={2} alignItems="center" sx={{ mt: "0px", ml: "0px" }}>
            <Grid item xs={2} display="inline-flex">
              <Box mt={1} display="flex" justifyContent="flex-start">
                <Typography style={{ fontWeight: "bold" }}>Expired Date</Typography>
              </Box>
            </Grid>
            <Grid item xs={10} display="inline-flex">
              <Box mt={1} ml={3} display="flex" justifyContent="flex-start">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  slotProps={{ textField: { variant: "standard" } }}
                  value={data.expiration_date ? dayjs(formatDateYMD_HMS(data.expiration_date)) : null}
                  onChange={(e) => {
                    const formattedDate = e ? dayjs(e).format('YYYY-MM-DD') : null;
                    console.log(formattedDate)
                    if (formattedDate === "Invalid Date") {
                      setValidate(true);
                    } else {
                      setValidate(false);
                      setData({ ...data, expiration_date: formattedDate });
                    }
                  }}
                  format="YYYY/MM/DD"
                />
              </LocalizationProvider>
              </Box>
            </Grid>
          </Grid>


          <Grid container spacing={2} justifyContent="flex-end">
            <Grid item textAlign="left">
              <Box mt={1}>
                <Box
                  mt={5}
                  padding="11px"
                  onClick={handleUpdate}
                  sx={{
                    backgroundColor: "#2699fb",
                    color: "white",
                    borderRadius: "4px",
                    "&:hover": {
                      cursor: "pointer",
                    },
                    width: "200px",
                  }}
                >
                  <Typography
                    variant="body1"
                    gutterBottom
                    textAlign="center"
                    m={0}
                    cursor="pointer"
                  >
                    Update
                  </Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default UserEdit;
